import { GetApplicationsQueryResult } from '@sdir/httpclient/lib/clients/aps/application';
import { readValidationEngine, ValidationEngine } from '../../../services/certreq/validationEngine';

/**
 * Sammenligner to søknads-Guid-er.
 *
 * Sammenligningen må være ufølsom for store/små bokstaver: `v2/application/{uid}`
 * svarer med Guid-en i STORE bokstaver (`97058B97-...`), mens ruteparameteren
 * står med små. Med `===` ble de aldri like, og siden ventet evig på en søknad
 * den allerede hadde. Tomme verdier håndteres av kallstedene, ikke her.
 */
export const sammeUid = (a?: string | null, b?: string | null): boolean =>
  (a || '').trim().toLowerCase() === (b || '').trim().toLowerCase();

/**
 * Hvilken motor søknaden på DENNE ruta skal vurderes av — eller `undefined` når
 * vi ennå ikke vet.
 *
 * Skillet mellom «legacy» og «vet ikke» er hele poenget. `readValidationEngine`
 * svarer `legacy` på alt den ikke kjenner igjen, en tom søknad inkludert, og et
 * kallsted som spør rett kan derfor ikke se forskjell på «søknaden bruker den
 * gamle motoren» og «søknaden er ikke hentet ennå». Begge kallstedene bruker
 * svaret til å sende brukeren et annet sted, og en gjetning ville sendt hen feil.
 *
 * Derfor svarer vi bare når resultatet FAKTISK er søknaden ruta gjelder. Rett
 * etter et uid-bytte ligger forrige søknad fortsatt i `result` — provideren
 * henter først i sin effekt — og uten sjekken ville forrige søknads motor blitt
 * lest som om den var den nye sin. Sammenligningen går gjennom `sammeUid` fordi
 * API-et og ruta ikke er enige om bokstavstørrelsen på Guid-en.
 */
export const applicationEngine = (
  result: GetApplicationsQueryResult | null | undefined,
  routeUid?: string | null
): ValidationEngine | undefined => {
  if (!result) return undefined;
  // Uten uid i ruta, eller uten uid i svaret, har vi ingenting å sammenligne —
  // da er søknaden vi har den eneste kandidaten.
  if (routeUid && result.uid && !sammeUid(result.uid, routeUid)) return undefined;
  return readValidationEngine(result);
};
